import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { featureKey, State } from 'app/virtual-event/features';

export const selectSummaryState = createFeatureSelector<State>(
  featureKey
);

export const selectVirtualEventSummary = createSelector(
  selectSummaryState,
  (state: State) => state.summary
);

export const selectVirtualEventProgress = createSelector(
  selectVirtualEventSummary,
  (summary: any) => {
    const result = (_.get(summary, 'total', 0) / _.get(summary, 'goal', 0)) * 100;
    return result > 100 ? 100: _.ceil(result);
  }
);
